/** Utah's words for checkin.ts. */
export const CHECKIN_UT = {
  /** Citation part: a hepatitis A or typhoid exclusion needs county approval to return (Utah practice with Food Code 2-201.13). */
  countyReturnCite: "Utah: county approval to return (hepatitis A, typhoid)",
} as const;
